/* eslint-disable @typescript-eslint/no-unsafe-assignment */
"use client"

import React from "react"
import { Controller, useFormContext } from "react-hook-form"
import { z } from "zod"

import type { CheckboxProps } from "./checkbox"
import { Checkbox } from "./checkbox"

type FormCheckboxProps = CheckboxProps & {
	name: string
}

export const CheckboxSchema = z.union([z.boolean(), z.literal("indeterminate")])

export const FormCheckbox = React.memo(
	({ name, ...props }: FormCheckboxProps) => {
		const {
			formState: { errors },
			control,
		} = useFormContext()
		const error = errors[name]

		return (
			<Controller
				name={name}
				control={control}
				render={({ field }) => {
					return (
						<Checkbox
							{...field}
							checked={field.value}
							onCheckedChange={(newValue) => {
								field.onChange(newValue)
								if (props.onCheckedChange) {
									props.onCheckedChange(newValue)
								}
							}}
							errorMessage={error ? String(error.message) : undefined}
							{...props}
						/>
					)
				}}
			/>
		)
	},
)
